---
title: What is an AI Expert persona?
summary: The core concept — a configurable expert that answers from its own knowledge.
visibility: public
audience: author-admin
section: Get started
order: 10
last_verified: 2026-06-19
owner: docs
---

# What is an AI Expert persona?

An **AI Expert persona** is a configurable expert you build once and let people
talk to. Each persona has its own identity, knowledge, and behavior.

A persona brings together:

- **Identity & personality** — who it is and how it speaks.
- **Knowledge (RAG)** — the documents it answers from, so replies are grounded.
- **Skills, tools, and workflows** — what it can *do*, not just say.
- **Presentation** — text chat, voice, or a video avatar.

You don't need to write code to build one. The rest of this guide walks through
creating your first persona and shaping how it behaves.
